<template>
    <div class="talkshow" v-show="talkIsShow == true" v-loading="talkloading">
        <div class="talkshowclose">
            <a @click="hiddentalkshow();">X</a>
        </div>
        <div class="talkshowdetail">
            {{npcTalk}}
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'npcTalk',
  data() {
    return {
        npcTalk: null,
        talkIsShow: null,
        talkloading: false
    };
  },
  computed: {
    ...mapState('street', ['fantasyTaskTodoBOList'])
  },
  mounted: function () {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy: function () {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    hiddentalkshow: function() {
        this.talkIsShow = false;
        this.npcTalk = "";
    },
    // 公共方法：打开交谈框并显示 loading（背包给道具时使用）
    openTalkLoading: function() {
        this.talkIsShow = true;
        this.talkloading = true;
    },
    // 公共方法：显示 NPC 回应文本
    showNpcTalk: function(msg) {
        this.talkIsShow = true;
        this.talkloading = false;
        this.npcTalk = msg;
    },
    showtalk: function(npcId) {
        let _this = this;
        _this.talkIsShow = true;
        _this.talkloading = true;
        //先判断当前npc是否是玩家的拜访目标
        let taskTo = false;
        let taskTodoId;
        for (let i=0; i<this.fantasyTaskTodoBOList.length; i++) {
            const fantasyTaskTodo = this.fantasyTaskTodoBOList[i];
            if (fantasyTaskTodo.taskTo == npcId && fantasyTaskTodo.taskStatus == 0
            && fantasyTaskTodo.taskType == 1) {
                taskTo = true;
                taskTodoId = fantasyTaskTodo.id;
                break;
            }
        }

        if (true == taskTo) {
            //调用拜访方法，修改当前待办任务的状态为条件达成
            postRequest('/npc/npc/visitNpc', {
                npcId: npcId,
                taskTodoId: taskTodoId
            }).then(resp=> {
                _this.talkloading = false;
                if (resp.status == 200) {
                    //成功
                    const respData = resp.data;
                    if (200 == respData.status) {
                        _this.$emit('task-finished', respData);
                    } else {
                        _this.npcTalk = respData.message;
                    }
                } else {
                    Message.error('用户非法⊙﹏⊙∥!');
                }
            }, resp=> {
                this.talkloading = false;
                this.talkIsShow = false;
                Message.error('用户非法⊙﹏⊙∥!');
            });
        } else {
            postRequest('/npc/npc/npcSays', {
                npcId: npcId
            }).then(resp=> {
                _this.talkloading = false;
                if (resp.status == 200) {
                //成功
                const respData = resp.data;
                if (200 == respData.status) {
                    _this.npcTalk = respData.message;
                } else {
                    _this.npcTalk = respData.message;
                }
                } else {
                //失败
                Message.error('用户非法⊙﹏⊙∥!');
                }
            }, resp=> {
                this.talkloading = false;
                this.talkIsShow = false;
                Message.error('用户非法⊙﹏⊙∥!');
            });
        }
    },
    //询问npc
    askNpc: function(npcId){
        let _this = this;
        this.$prompt('请输入想要询问的关键字', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputErrorMessage: '请输入关键字'
        }).then(({ value }) => {
            _this.talkIsShow = true;
            _this.talkloading = true;
            postRequest('/npc/npc/askNpc', {
                npcId: npcId,
                keyWord: value
            }).then(resp=> {
                _this.talkloading = false;
                if (resp.status == 200) {
                    //成功
                    const respData = resp.data;
                    if (200 == respData.status) {
                        _this.$emit('task-finished', respData);
                    } else {
                        _this.npcTalk = respData.message;
                    }
                } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!');
                }
            }, resp=> {
                Message.error('用户非法⊙﹏⊙∥!');
                _this.talkloading = false;
            });
        }, function () {
            //取消
            _this.$message({
            type: 'info',
            message: '取消询问'
          });
        })
    },
    // 移动端：点击交谈框外部关闭（点击弹窗/NPC浮层/头像/交谈框内部不关闭）
    handleDocumentClick: function(e) {
      if (window.innerWidth > 768) return;
      const el = e.target;
      // 点击弹窗/NPC浮层/头像时不做任何关闭
      // el-dialog 均 append-to-body（DOM 在 body 下，.pocket/.taskdiv 守卫够不到），
      // 必须加 .el-dialog 守卫，否则给道具的提示框会被同一次点击冒泡立即关掉（2026-10-01）
      if (el.closest('.pocket') || el.closest('.taskdiv') || el.closest('.npcdescdiv') || el.closest('.npcdiv > img') || el.closest('.el-dialog')) return;
      // 关闭交谈弹窗
      if (this.talkIsShow) {
        if (el.closest('.talkshow')) return;
        this.talkIsShow = false;
        this.npcTalk = "";
      }
    }
  }
}
</script>

<style scoped>
.talkshow {
	background-color:#F0FBEB;
    border:1px solid #9BDF70;
    width:300px;
    height:200px;
    position:absolute;
    z-index:500;
    top:50%;margin-top:-100px;
    left:50%;margin-left:-150px;
}
.talkshow .talkshowclose {
	height:20px;
	width:100%;
	background-color:#099;
	text-align:right;
	line-height:16px;
}
.talkshow .talkshowclose a {
	font-size:16px;
	padding:0 10px;
	cursor: pointer;
}
.talkshow .talkshowdetail {
	margin:5px;
	font-size:14px;
	line-height:1.5em;
	word-wrap:break-word;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  /* talkshow 移动端全屏 */
  .talkshow {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    max-width: 360px;
    height: auto;
    min-height: 140px;
    max-height: 55vh;
    margin: 0;
    box-shadow: 0 0 0 9999px rgba(0,0,0,0.4);
    border-radius: 8px;
    z-index: 500;
  }
  .talkshow .talkshowdetail {
    font-size: 14px;
    line-height: 1.5em;
    padding: 12px;
  }
  .talkshow .talkshowclose {
    height: 28px;
    line-height: 28px;
  }
  .talkshow .talkshowclose a {
    font-size: 18px;
    padding: 0 12px;
  }
}
</style>
